import { render, staticRenderFns } from "./ShowingNotification.vue?vue&type=template&id=4f8ca71e&"
import script from "./ShowingNotification.vue?vue&type=script&lang=ts&"
export * from "./ShowingNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ShowingNotification.vue?vue&type=style&index=0&id=4f8ca71e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports